import axios from "@/utils/axios";
import { propOr, pathOr, tap, path, compose, length } from "ramda";
import { NUMBER_ELEMENTS_PER_PAGE, SUBMISSION_ON_TIME, SUBMISSION_LATE, SUBMISSION_MISSED } from "@/constants/generic";
import { SET_CURRENT_ASSIGNMENT, ADD_ASSIGNMENTS, RESET_CURRENT_ASSIGNMENT } from "../constants";

const initialState = () => ({
  currentAssignment: {},
  list: {},
  AIPerformance: [],
  assessmentList: [
    {
      id: "0",
      children: [
        {
          id: "general_v5",
          label: "ELSA Standard Assessment",
          children: [
            // {
            //   label: 'Assessment sentence 1',
            //   options: {
            //     customContent: true,
            //     titleClassArray: ["level-3-title"]
            //   },
            // }
          ],
          options: {
            titleClassArray: ["assessment-level-1-title"],
            showIcon: true,
            iconClassArray: ["elsa-level-down", "elsa-game-type-assessment"],
            showListAction: true,
            assignAction: true,
            hideAddAction: true,
            asignActionText: "Assign to Class"
          },
          order: 0,
        },
      ],
      label: "ASSESSMENTS",
      options: {
        titleClassArray: ["root-title"],
        showTags: false,
        showIcon: false,
        iconClassArray: ["elsa-level-down", "elsa-game-type-pronunciation"],
        showListAction: true,
        assignAction: false,
        hideAddAction: true,
        asignActionText: "Assign to Class",
        showTotalItems: true,
        customContent: false,
        showSubTitle: true
      },
      order: 0,
    },
  ]
});

const state = initialState();

const getters = {
  getCurrentAssignment: propOr({}, "currentAssignment"),
  assignmentsSize: compose(length, pathOr([], ["list", "results"])),
  getAssignments: pathOr([], ["list", "results"]),
  buildPagination(state) {
    const pageCounter = getters.assignmentsSize(state);
    const numberPages = state.list.count / NUMBER_ELEMENTS_PER_PAGE;
    return {
      pageCounter,
      total: state.list.count || 0,
      next: state.list.next,
      previous: state.list.previous,
      numberPages: Math.floor(numberPages),
    };
  },
  getCurrentAssignmentId: path(["currentAssignment", "id"]),
};

const mutations = {
  [SET_CURRENT_ASSIGNMENT](state, assignment) {
    const nowTime = new Date().getTime();
    const dueDateTime = new Date(assignment.due_date).getTime();

    const performances = assignment.performances.map(item => {
      let submission_status = "";

      switch (true) {
        case (item.date_complete === "Not Started" || item.date_complete === "In Progress") && dueDateTime < nowTime:
          submission_status = SUBMISSION_MISSED;
          break;
        case new Date(item.date_complete).getTime() <= dueDateTime:
          submission_status = SUBMISSION_ON_TIME;
          break;
        case new Date(item.date_complete).getTime() > dueDateTime:
          submission_status = SUBMISSION_LATE;
          break;
        default:
          submission_status = "";
          break;
      }

      return {
        ...item,
        submission_status,
      };
    });

    state.currentAssignment = { ...assignment, performances };
  },
  [ADD_ASSIGNMENTS](state, assignment) {
    state.list = assignment;
  },
  [RESET_CURRENT_ASSIGNMENT](state) {
    state.currentAssignment = {};
  },
  setAIPerformance(list) {
    state.AIPerformance = list
  }
};

const actions = {
  getAssignment({ dispatch }, { classId, assignmentId } = {}) {
    return axios
      .get(`/v1/groups/${classId}/assignments/${assignmentId}`)
      .then(tap(response => dispatch("setCurrentAssignment", response.data)));
  },
  getAssignments({ commit, rootGetters }, params) {
    const { classId } = params;
    delete params.classId;
    const currentClassId = classId || rootGetters["classes/getCurrentClassId"];
    return axios.get(`/v1/groups/${currentClassId}/assignments`, { params }).then(response => {
      commit(ADD_ASSIGNMENTS, response.data);
      return response;
    });
  },
  setCurrentAssignment({ commit }, currentAssignment) {
    currentAssignment && commit(SET_CURRENT_ASSIGNMENT, currentAssignment);
  },
  deleteAssignment({ rootGetters }, assignmentId) {
    const currentClassId = rootGetters["classes/getCurrentClassId"];
    return axios.delete(`/v1/groups/${currentClassId}/assignments/${assignmentId}`);
  },
  updateAssignment({ dispatch, rootGetters }, { classId, assignmentId, payload } = {}) {
    return axios
      .patch(`/v1/groups/${classId}/assignments/${assignmentId}`, payload)
      .then(tap(response => dispatch("setCurrentAssignment", response.data)));
  },
  getUserAssignmentHistory({ dispatch }, { userId, assignmentId } = {}) {
    return axios.get(`/v1/reports/user/${userId}/assignment-history/${assignmentId}`).then(response => response.data);
  },

  resetCurrentAssignment({ commit }) {
    commit(RESET_CURRENT_ASSIGNMENT);
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
